import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Box,
  Skeleton,
} from '@mui/material';
import { SlowQuery } from '../../../../types/admin';

interface SlowQueryTableProps {
  queries: SlowQuery[];
  loading?: boolean;
}

export default function SlowQueryTable({ queries, loading }: SlowQueryTableProps) {
  if (loading) {
    return (
      <Card sx={{ height: 400 }}>
        <CardContent>
          <Skeleton variant="text" width="60%" height={32} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" width="100%" height={300} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ height: 400 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Slow Queries (&gt;1s)
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Top 5 slowest queries with optimization suggestions
        </Typography>

        <TableContainer sx={{ maxHeight: 300 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Query</TableCell>
                <TableCell align="right">Duration (ms)</TableCell>
                <TableCell align="right">Count</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {queries.map((query, index) => (
                <TableRow key={index} hover>
                  <TableCell>
                    <Box>
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: 'monospace',
                          fontSize: '0.75rem',
                          maxWidth: 400,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          mb: 0.5,
                        }}
                      >
                        {query.query}
                      </Typography>
                      <Chip label={query.table} size="small" sx={{ mr: 1 }} />
                      {query.suggestion && (
                        <Typography variant="caption" color="primary">
                          💡 {query.suggestion}
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2" sx={{ color: query.avg_duration_ms > 2000 ? '#d32f2f' : '#ed6c02' }}>
                      {query.avg_duration_ms.toFixed(0)}ms
                    </Typography>
                  </TableCell>
                  <TableCell align="right">{query.execution_count}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
